import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { TopicTimeBounds } from "../TopicRecord";

/**
 * The time span a dataset's topics cover, without listing them.
 *
 * Its one caller today is the chat's t=0 picker, which offers "start of
 * <dataset>" for everything in the thread's context: folding the same answer
 * out of `useDatasetTopics` meant paging every topic of every file in each
 * suggested dataset while the reader waited on a popover.
 */
export function useDatasetTopicTimeBounds(
  datasetId: string,
  isEnabled: boolean,
) {
  const { topics: topicService } = useDomainServices();

  return useQuery<TopicTimeBounds, Error>({
    queryKey: ["datasetTopicTimeBounds", datasetId],
    queryFn: ({ signal }) =>
      topicService.getTimeBoundsForDataset(datasetId, { abortSignal: signal }),
    enabled: isEnabled,
    // Bounds move only when files are added to the dataset or reingested, so
    // they age at the same rate the topic records themselves do.
    staleTime: 300000, // 5 minutes, in milliseconds
  });
}
